export default "__VITE_ASSET__BY8UPO9m__"